import React from "react";
import { FaBalanceScale, FaHandshake, FaGavel, FaShieldAlt } from "react-icons/fa";
// Import your background image of the scales/courtroom here
import courtroomBg from "../../assets/images/Herosection/herobanner.jpg"; // replace with your image path

const WhyChooseUs = () => {
  const brandGold = "#E3B66B";

  const pillars = [
    {
      title: "19+ Years of Mastery",
      desc: "A legacy of transparency and results-driven advocacy in Delhi's highest courts.",
      icon: <FaBalanceScale />,
    },
    {
      title: "Client-First Ethics",
      desc: "Every case is handled with precision, strategy, and a commitment to your peace of mind.",
      icon: <FaHandshake />,
    },
    {
      title: "Strategic Litigation",
      desc: "From first consultation to final outcome, we stand by you with consistent courtroom clarity.",
      icon: <FaShieldAlt />,
    },
    {
      title: "Dedicated Advocacy",
      desc: "Specialized expertise across civil, criminal, corporate, and matrimonial legal matters.",
      icon: <FaGavel />,
    },
  ];

  return (
    <section className="relative overflow-hidden font-serif">
      {/* UPPER HERO SECTION: DARK OVERLAY */}
      <div className="relative py-24 lg:py-32 px-6">
        {/* Background Image with Dark Green Overlay */}
        <div className="absolute inset-0 z-0">
          <img 
            src={courtroomBg} 
            alt="Nyaysakti Law Chambers" 
            className="w-full h-full object-cover grayscale brightness-[0.2]"
          />
          <div className="absolute inset-0 bg-[#0B1C2D]/80"></div>
        </div>

        <div className="max-w-7xl mx-auto relative z-10 text-center">
          <p className="uppercase tracking-[0.5em] text-xs font-bold mb-6" style={{ color: brandGold }}>
            Nyaysakti Law Firm
          </p>
          <h2 className="text-4xl md:text-6xl text-white font-bold mb-10 tracking-tight leading-tight">
            Why Clients <br /> <span className=" font-light opacity-80">Choose Our Counsel</span>
          </h2>
          <div className="max-w-3xl mx-auto">
            <p className="text-gray-300 text-lg md:text-xl leading-relaxed font-sans font-light">
              Trusted for our transparency, dedication, and results. 
              We combine deep legal expertise with a genuine commitment to client success, 
              ensuring every case is handled with surgical precision.
            </p>
          </div>
        </div>
      </div>

      {/* LOWER CONTENT: THE PILLARS GRID */}
      <div className="bg-[#FCFAF7] py-20 px-6">
        <div className="max-w-7xl mx-auto -mt-32 relative z-20">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 shadow-2xl">
            {pillars.map((item, index) => (
              <div 
                key={index} 
                className="bg-white p-10 border-r border-gray-100 last:border-none group hover:bg-[#0B1C2D] transition-all duration-500"
              >
                <div 
                  className="text-3xl mb-6 transition-colors duration-500 group-hover:text-white"
                  style={{ color: brandGold }}
                >
                  {item.icon}
                </div>
                <h4 className="text-xl font-bold text-[#0A1D1B] mb-4 group-hover:text-white transition-colors duration-500">
                  {item.title}
                </h4>
                <p className="text-gray-500 text-sm leading-relaxed font-sans group-hover:text-gray-400 transition-colors duration-500">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          {/* FLOATING CTA CARD */}
          <div className="mt-20 max-w-4xl mx-auto  rounded-xl bg-[#0B1C2D] border border-gray-100 p-12 text-center shadow-xl relative">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-[2px]" style={{ backgroundColor: brandGold }}></div>
            <h3 className="text-3xl md:text-4xl font-bold text-[#fff] mb-4">
              Got a Problem? Consult With Us
            </h3>
            <p className="text-white font-sans mb-10 max-w-2xl mx-auto">
              Facing a legal issue? Nyaysakti provides expert guidance and practical solutions 
              to protect your rights.
            </p>
            <a 
              href="/contact-us"
              className="inline-block px-10 py-4 font-bold tracking-widest text-[#0A1D1B] hover:text-white transition-all duration-500 uppercase text-xs"
              style={{ border: `1px solid ${brandGold}`, backgroundColor: brandGold }}
            >
              Schedule Consultation Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;